import { supabase } from '@/integrations/supabase/client';

const getCookie = (name: string): string =>
  document.cookie.match(`(^|;)\\s*${name}=([^;]*)`)?.[2] || '';

/**
 * Track a custom goal event via DataFast.
 * Fire-and-forget — never throws, silently skips if no visitor cookie exists.
 */
export function trackGoal(name: string, metadata?: Record<string, string>): void {
  try {
    const visitorId = getCookie('datafast_visitor_id');
    if (!visitorId) return; // user hasn't accepted cookies or DataFast not loaded

    supabase.functions
      .invoke('track-goal', {
        body: { datafastVisitorId: visitorId, name, metadata },
      })
      .catch(() => {}); // swallow errors — analytics should never break the app
  } catch {
    // swallow
  }
}
